<div class="container">
  <ng-container *ngIf="isShowIdentifierBlock">
    <div
      class="row"
      *ngIf="
        !!isfEntity.entityIdentifier ||
        getValidationText(isfEntity, 'identifier') ||
        !!isfEntity.entityIdentifierQualifier ||
        getValidationText(isfEntity, 'identifierQualifier')
      "
    >
      <div class="col-12 col-sm-6">{{ "LABELS.ID_NUMBER" | translate }}</div>
      <ng-container
        *ngIf="!getValidationText(isfEntity, 'identifier') && !getValidationText(isfEntity, 'identifierQualifier'); else missedIdentifier"
      >
        <div class="col-12 col-sm-6">
          {{ "IDENTIFIER_QUALIFIER." + isfEntity.entityIdentifierQualifier | translate }} {{ isfEntity.entityIdentifier | identifier }}
        </div>
      </ng-container>
      <ng-template #missedIdentifier>
        <div class="col-12 col-sm-6 text-error">
          {{ getValidationText(isfEntity, "identifier") || getValidationText(isfEntity, "identifierQualifier") | translate }}
        </div>
      </ng-template>
    </div>
    <div class="row" *ngIf="!!isfEntity.dateOfBirth || getValidationText(isfEntity, 'dateOfBirth')">
      <div class="col-12 col-sm-6">{{ "FORM_LABEL.DATEOFBIRTH" | translate }}</div>
      <ng-container *ngIf="!getValidationText(isfEntity, 'dateOfBirth'); else missedDateOfBirth">
        <div class="col-12 col-sm-6">{{ isfEntity.dateOfBirth | customDateByUtc }}</div>
      </ng-container>
      <ng-template #missedDateOfBirth>
        <div class="col-12 col-sm-6 text-error">{{ getValidationText(isfEntity, "dateOfBirth") | translate }}</div>
      </ng-template>
    </div>
  </ng-container>
  <div class="row" *ngIf="!!isfEntity.name || getValidationText(isfEntity, 'name')">
    <div class="col-sm-6">{{ "LABELS.NAME" | translate }}</div>
    <ng-container *ngIf="!getValidationText(isfEntity, 'name'); else missedName">
      <div class="col-12 col-sm-6">{{ isfEntity.name }}</div>
    </ng-container>
    <ng-template #missedName>
      <div class="col-12 col-sm-6 text-error">{{ getValidationText(isfEntity, "name") | translate }}</div>
    </ng-template>
  </div>
  <div class="row" *ngIf="!!isfEntity.address || getValidationText(isfEntity, 'address')">
    <div class="col-12 col-sm-6">{{ "LABELS.ADDRESS" | translate }}</div>
    <ng-container *ngIf="isValidIsfEntityAddress(); else missedAdd">
      <div class="col-12 col-sm-6" *ngIf="!getValidationText(isfEntity, 'address')">
        <address-details [address]="isfEntity.address"></address-details>
      </div>
      <div class="col-12 col-sm-6 text-error" *ngIf="getValidationText(isfEntity, 'address')">
        {{ getValidationText(isfEntity, "address") | translate }}
      </div>
    </ng-container>
    <ng-template #missedAdd>
      <div class="col-12 col-sm-6 text-error">
        {{ "BACK_ERROR.MISSING_ADDRESS_PARTS" | translate }}
      </div>
    </ng-template>
  </div>
</div>
